import { useEffect, useState } from 'react'
import { useNls } from '../../nls/nlsProvider'

type ConnectivityPillProps = {
  syncState?: string
}

export const ConnectivityPill = ({ syncState }: ConnectivityPillProps) => {
  const [online, setOnline] = useState(() => typeof navigator === 'undefined' ? true : navigator.onLine)
  const { t } = useNls()

  useEffect(() => {
    const refresh = () => setOnline(typeof navigator === 'undefined' ? true : navigator.onLine)
    window.addEventListener('online', refresh)
    window.addEventListener('offline', refresh)
    return () => {
      window.removeEventListener('online', refresh)
      window.removeEventListener('offline', refresh)
    }
  }, [])

  const label = !online ? t('NLSChatStatusOffline') : syncState && syncState !== 'IDLE' ? syncState : t('NLSChatStatusOnline')
  return <span className={`chatConnectivityPill ${online ? 'isOnline' : 'isOffline'}`}>{label}</span>
}
